module.exports = __webpack_public_path__ + "static/img/ndvi4.78b5113e.jpg";